import { createReducer } from "@reduxjs/toolkit";
import moment from "moment";
import { getElencoDatiDashboard, getElencoLotti, setCampagna, setDataFine, setDataInizio } from "./actions";
import { HomeDashboardReducerType } from "./types";

const initialState: HomeDashboardReducerType = {
  form: {
    dataInizio: moment().subtract('7', 'days').toDate(),
    dataFine: moment().toDate(),
    idLotto: undefined
  },
  elencoDatiDashboard: undefined,
  elencoLotti: undefined
}

export const homeDashboardReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setDataInizio, (state, action) => {
      state.form.dataInizio = action.payload;
    })
    .addCase(setDataFine, (state, action) => {
      state.form.dataFine = action.payload;
    })
    .addCase(getElencoDatiDashboard.pending, (state) => {
      state.elencoDatiDashboard = initialState.elencoDatiDashboard;
    })
    .addCase(getElencoDatiDashboard.fulfilled, (state, action) => {
      if (action.payload) {
        state.elencoDatiDashboard = action.payload;
      }
    })
    .addCase(getElencoDatiDashboard.rejected, (state, action) => {
      console.log('getElencoDatiDashboard.rejected', action);
    })

    .addCase(getElencoLotti.pending, (state) => {
      state.elencoLotti = initialState.elencoLotti;
    })
    .addCase(getElencoLotti.fulfilled, (state, action) => {
      if (action.payload) {
        state.elencoLotti = action.payload;
      }
    })
    .addCase(getElencoLotti.rejected, (state, action) => {
      console.log('getElencoLotti.rejected', action);
    })
    .addCase(setCampagna, (state, action) => {
      state.form.idLotto = action.payload;
    })
});
